import { ToastContainer } from "react-toastify";
import ContactUs from "./ContactUs/ContactUs";
import Courses from "./Courses/Courses";
import Hero from "./Hero/Hero";
import Instructors from "./Instructors/Instructors";
import Footer from "./layout/Footer";
import MobileApp from "./MobileApp/MobileApp";
import Overview from "./Overview/Overview";
import Sections from "./Sections/Sections";
import { useFETCH } from "./Tools/APIs/useMyAPI";
import Loading from "./Tools/Loading/Loading";
import Video from "./Video/Video";
import Offers from "./Offers/Offers";
import Overview2 from "./Overview/Overview2";

function App() {
  const { data, isLoading } = useFETCH(`home`);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <ToastContainer position="top-center" style={{ zIndex: "9999999999" }} />
      <ToastContainer />
      <div className="App  flex-col gap-10 flex">
        <Hero data={data} />
        <Video data={data} />
        <Offers data={data} />
        <Overview data={data} />
        <Sections data={data} />
        <MobileApp data={data} />
        <Overview2 />
        <Instructors data={data} />
        <ContactUs data={data} />
        <Footer data={data} />
      </div>
    </>
  );
}

export default App;
